module.exports = __webpack_public_path__ + "img/watch.712dcd26.svg";